<template>
  <div>
    <div class="devices">
      <p>
        This application does not currently support mobile devices
        <br />For a better experience please use a desktop pc.
      </p>
    </div>
    <Header
      v-if="
        $route.name !== 'home' &&
        $route.name !== 'forgot' &&
        $route.name !== 'signup'
      "
    />
    <div class="global-container">
      <div
        class="main-menu"
        v-if="
          $route.name !== 'home' &&
          $route.name !== 'verifyEmail' &&
          $route.name !== 'forgot' &&
          $route.name !== 'signup'
        "
      >
        <ul>
          <li
            :class="{
              active:
                $route.name === 'athletes' || $route.name === 'athleteProfile',
            }"
          >
            <a
              @click="
                clearFilters();
                $router.push('/athletes');
              "
            >
              <font-awesome-icon icon="running" />Athletes
            </a>
          </li>
          <li
            :class="{
              active:
                $route.name === 'events' || $route.name === 'eventProfile',
            }"
          >
            <a
              @click="
                clearFilters();
                $router.push('/events');
              "
            >
              <font-awesome-icon icon="calendar-week" />Events
            </a>
          </li>
          <li
            :class="{
              active:
                $route.name === 'highSchools' ||
                $route.name === 'highSchoolProfile',
            }"
          >
            <a
              @click="
                clearFilters();
                $router.push('/highSchools');
              "
            >
              <font-awesome-icon icon="building" />High Schools
            </a>
          </li>

          <li
            :class="{
              active: $route.name === 'clubs' || $route.name === 'clubProfile',
            }"
          >
            <a
              @click="
                clearFilters();
                $router.push('/clubs');
              "
            >
              <font-awesome-icon icon="users" />Club Teams
            </a>
          </li>

          <li
            :class="{
              active: $route.name === 'profile' || $route.name === 'profile',
            }"
          >
            <a @click="$router.push('/profile')">
              <font-awesome-icon icon="cog" />Settings
            </a>
          </li>
          <li>
            <a @click="showDialog">Submit Feedback</a>
            <!-- <a href="mailto: playersdirectory@imlcacoaches.com">Submit Feedback</a> -->
          </li>
          <li>
            <a>
              <download-csv
                class="btn btn-default"
                :data="exportAthletes"
                name="favorites.csv"
              >
                Export Favorites
              </download-csv></a
            >
          </li>
        </ul>
        <DownloadApp />

        <modals-container />
      </div>
      <router-view></router-view>
    </div>

    <notifications
      group="feedback"
      position="bottom center"
      classes="feedback-notif"
    />
    <notifications
      group="feedback-error"
      position="bottom center"
      classes="feedback-error-notif"
    />
    <!-- <Footer v-if="$route.name !== 'home' && $route.name !== 'forgot' && $route.name !== 'signup'"/> -->
  </div>
</template>

<script>
import Header from "@/components/Header";
import DownloadApp from "@/components/DownloadApp";
import Footer from "@/components/Footer";
import Feedback from "@/views/Feedback.vue";
import { mapMutations } from "vuex";
import { db } from "./db";

export default {
  components: {
    Header,
    DownloadApp,
  },
  data() {
    return {
      athletes: [],
    };
  },
  created() {
    this.$bind(
      "athletes",
      db
        .collection("athletes")
        .where("usersFavorited", "array-contains", this.$store.state.coach.ref),
      { maxRefDepth: 0 }
    );
  },
  computed: {
    exportAthletes() {
      return this.athletes.map((athlete) => {
        return {
          firstName: athlete.firstName,
          lastName: athlete.lastName,
          email: athlete.email,
          parentName: athlete.parentName,
          parentEmail: athlete.parentEmail,
          phone: athlete.phone,
          gradYear: athlete.graduatingYear,
          position: athlete.positionObject ? athlete.positionObject.name : null,
          highSchool: athlete.highSchoolObject
            ? athlete.highSchoolObject.name
            : null,
          highSchoolCoach: athlete.highSchoolCoachName,
          highSchoolCoachEmail: athlete.highSchoolCoachEmail,
          highSchoolCoachPhone: athlete.highSchoolCoachPhone,
          highSchoolJerseyNumber: athlete.schoolJerseyNumber,
          club: athlete.clubObject ? athlete.clubObject.name : null,
          clubCoach: athlete.clubCoachName,
          clubCoachEmail: athlete.clubCoachName,
          clubCoachPhone: athlete.clubCoachPhone,
          clubJerseyNumber: athlete.clubJerseyNumber,
          highlightVideo:
            athlete.highlightVideo && athlete.highlightVideo.includes("http")
              ? athlete.highlightVideo
              : "https://" + athlete.highlightVideo,
          gpa: athlete.gpa,
          satScore: athlete.sat,
          actScrore: athlete.act,
          address: athlete.address ? athlete.address.street : null,
          city: athlete.address ? athlete.address.city : null,
          state: athlete.address ? athlete.address.state : null,
          zip: athlete.address ? athlete.address.zip : null,
        };
      });
    },
  },
  methods: {
    ...mapMutations(["clearFilters"]),
    showDialog() {
      this.$modal.show(Feedback, {
        draggable: false,
      });
    },
  },
};
</script>

<style lang="scss">
@import url("https://fonts.googleapis.com/css?family=Oswald&display=swap");

html {
  box-sizing: border-box;
  font-family: Oswald, sans-serif;
}
* {
  margin: 0;
  padding: 0;
}
*,
:after,
:before {
  box-sizing: inherit;
  font-family: inherit;
}

.devices {
  background: #002f53;
  position: fixed;
  width: 100%;
  height: 100%;
  z-index: 9999;
  display: none;
}

.devices p {
  color: #fff;
  position: absolute;
  left: 0;
  right: 0;
  margin: 0 auto;
  top: 50%;
  transform: translateY(-50%);
  text-align: center;
  font-size: 28px;
}

.global-container {
  display: flex;
  flex-wrap: wrap;
  height: 100vh;
}

.main-menu {
  width: 20.7777%;
  background: #002f53;
  position: relative;
}

.main-menu:before {
  content: "";
  position: fixed;
  top: 0;
  height: 100%;
  width: 20.7777%;
  background: #002f53;
  z-index: -1;
}

.main-menu ul li {
  border: 1px solid #707070;
}

.main-menu ul li a {
  color: #fff;
  font-size: 23px;
  padding: 7px 25px;
  display: block;
}

.main-menu ul li a svg {
  margin-right: 20px;
}

.main-menu ul li.active,
.main-menu ul li:hover {
  background: #fff;
}

.main-menu ul li.active a,
.main-menu ul li:hover a {
  color: #707070;
}

.main-menu ul li a svg {
  width: 30px !important;
}

.container {
  width: 79.2222%;
  background: #fff;
  padding-bottom: 50px;
  position: absolute;
  right: 0;
  top: 103.5px;
}

/* Back Button */
.back-btn {
  padding: 23px 50px;
  border: 1px solid #707070;
  border-bottom: 1px solid #707070;
  border-right: none;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.back-btn a {
  color: #1a348d;
  font-size: 16px;
  font-weight: normal;
  text-decoration: none;
}

/* Search container */
.search-container {
  padding: 17px;
  border: 1px solid #707070;
  border-bottom: 1px solid #707070;
  border-right: none;
}

.search-container input {
  border-radius: 50px;
  box-shadow: 2px 2px 3px rgba(0, 0, 0, 0.16);
  padding: 7px;
  border: 1px solid #707070;
  max-width: 1236px;
  width: 100%;
  margin: 0 auto;
  display: block;
  background: url("assets/icons/search.png");
  background-repeat: no-repeat;
  background-size: 27px;
  background-position: 10px;
  padding-left: 50px;
  outline: none;
  font-size: 16px;
  font-family: Helvetica Neue, Helvetica, Arial, sans-serif;
}

/* Table */
table {
  width: 100%;
  border-collapse: collapse;
}

table tr {
  border-bottom: 1px solid #707070;
}

table tr th {
  font-family: Helvetica Neue, Helvetica, Arial, sans-serif;
  font-size: 18px;
  text-align: left;
  padding: 22px 15px 10px;
  border-bottom: 1px solid #707070;
  border-top: 0px;
  position: relative;
}

table tr th span {
  padding-right: 15px;
}

table tr th span.only-bm {
  padding-right: 0px;
  position: absolute;
  bottom: 10px;
}

table tr th select {
  font-family: Helvetica Neue, Helvetica, Arial, sans-serif;
  font-size: 18px;
  font-weight: bold;
  border: none;
  padding: 2px 10px;
  outline: none;
  cursor: pointer;
  border: 1px solid #707070;
  box-shadow: 2px 2px 2px rgba(0, 0, 0, 0.3);
  border-radius: 5px;
  width: 102px;
  color: #707070;
  font-weight: normal;
}

table tr td {
  font-family: Helvetica Neue, Helvetica, Arial, sans-serif;
  padding: 2px 15px;
  font-size: 15px;
  border-bottom: 1px solid #707070;
}

table tr th:first-child,
table tr td:first-child {
  border-right: none;
}

table tr th:nth-child(2),
table tr td:nth-child(2) {
  border-left: none;
  border-right: 1px solid #707070;
}

table tr th:nth-child(2),
table tr td:nth-child(2) {
  border-left: none;
}

table tr td.star-icon {
  text-align: center;
  cursor: pointer;
  &.favourited {
    filter: invert(22%) sepia(41%) saturate(4930%) hue-rotate(341deg)
      brightness(87%) contrast(100%);
  }
}

table tr td a {
  font-family: Helvetica Neue, Helvetica, Arial, sans-serif;
  color: #1a348d;
  font-weight: normal;
}

.btn-container {
  justify-content: center;
  margin-top: 20px;
}
.btn-container,
.switch-container {
  display: flex;
}

/* Switch Tab */
.switch-tab {
  width: 100%;
}

.switch-tab button {
  width: 50%;
  font-size: 38px;
  color: #000;
  line-height: 70px;
  background: transparent;
  border: 1px solid #707070;
  width: 100%;
  border-top: none;
}

.switch-tab button:last-child {
  border-left: none;
}

/*
.switch-tab button.active {
    background: #002f53;
    color: #fff;
}
*/

/* Switch Buttons */
.switch-container {
  margin-bottom: 30px;
}
.switch-container button {
  font-family: Helvetica Neue, Helvetica, Arial, sans-serif;
  font-size: 18px;
  padding: 5px;
  border: none;
  box-shadow: 2px 2px 3px rgba(0, 0, 0, 0.4);
  cursor: pointer;
  width: 161px;
  border-radius: 5px;
  color: #727272;
}
.switch-container button.active {
  background-color: #005fa8;
  color: #fff;
  position: relative;
  top: 1px;
}
.switch-container button:focus {
  outline: none;
}

/* Load More Button */
button.loadmore {
  margin-top: 24px;
  width: auto;
  background-color: #002f53;
  padding: 15px 35px;
  border: none;
  color: #fff;
  text-transform: uppercase;
  font-weight: 500;
  cursor: pointer;

  &.favorites {
    margin-top: 0px;
    padding: 5px 5px;
    width: 86px;
    font-size: 12px;
  }
}

button.clipboad {
  background: #002f53;
  color: #fff;
  border: none;
  line-height: 30px;
  width: 120px;
  margin-left: 10px;
  border-radius: 5px;
  cursor: pointer;
}

button.loadmore.disabled,
button.clipboad.disabled {
  cursor: not-allowed;
  background-color: #414141;
}

ul {
  list-style: none;
}

li {
  padding: 5px 0;
}
a {
  color: #02568e;
  transition: all 0.2s;
  cursor: pointer;
}
a:hover {
  color: #000a10;
}
svg {
  margin-right: 5px;
}
.nav {
  display: block;
  width: 500px;
}
.nav li,
.nav ul {
  display: flex;
}
.nav li {
  flex: 1;
}
.nav li:not(:last-child) {
  margin-right: 5px;
}
.nav a {
  flex: 1;
  text-align: center;
  padding: 5px;
}
.nav a.active,
.nav a:hover {
  background-color: #02568e;
  color: #fff;
}
.global-nav {
  width: 100%;
  padding: 20px;
}
.home-nav {
  width: 500px;
}

.field {
  display: flex;
  align-items: center;
}
.field:not(:last-child) {
  margin-bottom: 25px;
}
.field > .vdp-datepicker {
  flex: 1;
}
.field > .vdp-datepicker > div > input {
  padding: 5px 10px;
  border-radius: 0;
  box-shadow: 1px 1px 2px rgba(0, 0, 0, 0.2);
  border-width: 0;
  color: #02568e;
  background: #f9f9f9;
  height: 36px;
  font-size: 16px;
  font-weight: 400;
  width: 315px;
  margin-left: 20px;
}
.field > .vdp-datepicker > div > input:focus {
  outline: none;
}
label {
  color: #363636;
  font-size: 16px;
  font-weight: 700;
  padding-left: 20px;
  text-align: end;
}
.alert-success {
  color: #155724;
  background-color: #d4edda;
  border-color: #c3e6cb;
  text-align: center;
}
.alert {
  position: relative;
  padding: 0.75rem 1.25rem;
  margin-top: 1rem;
  border: 1px solid transparent;
  border-radius: 0.25rem;
}
@media only screen and (max-width: 1366px) {
  footer[data-v-40ab164b] {
    position: relative;
    margin-left: auto;
    margin-top: -114px;
  }

  .global-container {
    min-height: 100%;
    height: 100%;
  }
}

@media only screen and (max-width: 768px) {
  .devices {
    display: block;
  }
}

.commited {
  background-color: #e1f5fe;
}

.premium {
  background-color: #fffde7;
}

.table-select {
  margin-top: 5px;
  &:not(.interested) {
    width: 130px;
  }
}

a {
  text-decoration: none;
}

.vue-notification-group {
  bottom: 10px !important;
}

.feedback-notif {
  background-color: #02568e !important;
  padding: 10px !important;
  font-size: 16px !important;
  color: white !important;
}

.feedback-error-notif {
  background-color: #f44336 !important;
  padding: 10px !important;
  font-size: 16px !important;
  color: white !important;
}
</style>
